import safeEval from "notevil";
import _ from "lodash";

const ExpressionFunctions = {
  strlen(s) {
    return s.length;
  },
  isYes(val) {
    return val === true;
  },
  isNo(val) {
    return val === false;
  },
  isNA(val) {
    return val === null;
  },
  sum(list, field) {
    return _.sumBy(list, function (o) {
      return Number(o[field] || 0);
    });
  },
  min(list, field) {
    return _.minBy(list, function (o) {
      return Number(o[field] || 0);
    });
  },
  max(list, field) {
    return _.maxBy(list, function (o) {
      return Number(o[field] || 0);
    });
  },
  avg(list, field) {
    return _.meanBy(list, function (o) {
      return Number(o[field] || 0);
    });
  },
  to_decimals(number, decimals) {
    return Number(number).toFixed(decimals);
  },
};

export function evalExpression(expression, item) {
  return safeEval(expression, {
    item,
    ...ExpressionFunctions,
  });
}
